import type { FileAccessTokenProvider } from "../../file/index.js";
import { config } from "../../config/config.js";
import type { Project } from "./Project.js";

export class ProjectAvatarAccessTokenProvider
  implements FileAccessTokenProvider
{
  public readonly project: Project;

  public constructor(project: Project) {
    this.project = project;
  }

  public createUploadToken() {
    return config.behaviors.project.createAvatarUploadToken(this.project.id);
  }
}
